import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const oliveColor = theme.palette.brand?.altamiraOlive || '#2B3A1D';

  return (
    <Box>
      <Box marginBottom={0}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Estratégica
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
        >
          Hotel Altamira Village x TNO Network
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 3 }}
        >
          Hospitalidad y Bienestar: La Evolución de la Experiencia
        </Typography>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            borderLeft: `5px solid ${oliveColor}`,
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>1. El Valor de la Alianza</strong>
          </Typography>
          <Box display="flex" justifyContent="center" sx={{ my: 2 }}>
            <Box
              component="img"
              src="/images/Logo.png"
              alt="Altamira Village - Hotel & Suites"
              sx={{
                width: '100%',
                maxWidth: 260,
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
          <Typography variant="body1" color="textSecondary" align="center">
            El Hotel Altamira Village es un icono de exclusividad en Caracas. TNO
            Network, como plataforma pionera en streaming, es el aliado natural
            para proyectar esa sofisticación en una infraestructura tecnológica
            impecable, moderna y disruptiva.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
